var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn } from 'typeorm';
/**
 * ObjectTransfer is parsed object transfer transaction , including
 * both send and receive transactions.
 */
let ObjectTransfer = class ObjectTransfer {
    id;
    txDigest;
    msafeAddress;
    objectId;
    objectVersion;
    objectType;
    sender;
    receiver;
    executedAt;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], ObjectTransfer.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], ObjectTransfer.prototype, "txDigest", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], ObjectTransfer.prototype, "msafeAddress", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], ObjectTransfer.prototype, "objectId", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], ObjectTransfer.prototype, "objectVersion", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], ObjectTransfer.prototype, "objectType", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], ObjectTransfer.prototype, "sender", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], ObjectTransfer.prototype, "receiver", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], ObjectTransfer.prototype, "executedAt", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], ObjectTransfer.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], ObjectTransfer.prototype, "createdAt", void 0);
ObjectTransfer = __decorate([
    Entity({ name: 'object_transfer' })
], ObjectTransfer);
export { ObjectTransfer };
//# sourceMappingURL=module.js.map